import Link from "next/link";
import { Card, Button } from "antd";
import Icon from "@ant-design/icons";
import EditIcon from "~/components/app/EditIcon";
import WarningIcon from "~/components/icons/WarningIcon";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showAppModal } from "~/redux/actions/app";
import usePrefs from "~/hooks/usePrefs";

const SiderPostJob = (props) => {
  const { prefs } = usePrefs();
  const handleLinkToNewJob = () => {
    if (!props.token) {
      props.showAppModal("PhoneSigninModal");
      return;
    }
    if (prefs.job_post_ui_version === "v2") {
      props.showAppModal("NewJobModalV2");
    } else {
      props.showAppModal("NewJobModal");
    }
  };
  return (
    <Card>
      <div className="sider-post-job">
        <Button
          className="sider-post-job-button"
          type="primary"
          onClick={handleLinkToNewJob}
        >
          <Icon
            component={EditIcon}
            style={{ color: "white" }}
          />
          发布招聘
        </Button>
        <div className="sider-post-job-separator" />
        <div className="sider-post-job-rules">
          <WarningIcon style={{ color: "#f9ba48" }} />
          <Link
            className="sider-post-job-rules-link"
            href="https://eleduck.com/posts/1nfKjE"
            target="_blank"
            style={{
              color: "#f9ba48",
              fontSize: "12px",
              textDecoration: "underline",
            }}
          >
            发布规则
          </Link>
        </div>
      </div>
      <style jsx>
        {`
          .sider-post-job {
            display: flex;
            flex-direction: column;
            gap: 12px;
            align-items: stretch;
          }
          .sider-post-job-separator {
            height: 1px;
            background-color: #f8f8f8;
          }
          .sider-post-job-rules {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
          }
          .sider-post-job-rules-link {
            text-decoration: underline;
            color: #f9ba48;
            font-size: 12px;
          }
        `}
      </style>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiderPostJob);
